module.exports = __webpack_public_path__ + "img/avatar-mark.7b82dbea.png";